// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__nl1WF","footer":"ModalCreateQualiphyProcedure_footer__TTaN1","additionData":"ModalCreateQualiphyProcedure_additionData__2PE3n"};